/**
 * Core engine implementation
 * @module @repo/engine/core
 */

// Core types and interfaces
export type {
  Engine,
  EngineFeatures,
  TableRef,
  TableRegistrationOptions,
  RegisterTableParams,
  TableChangeCallback,
  ExportToURLOptions
} from './engine';

// Core implementations
export {
  BaseEngine
} from './engine';

// Table data types and implementations
export type {
  TableSchema,
  ColumnSchema,
  Query,
  MaterializeOptions,
  TableDataSource,
  QueryOptions,
  SelectQueryOptions,
  AggregateQueryOptions,
  SQLQueryOptions,
  ColumnRef,
  OrderByClause,
  AggregateClause,
  RowLimit,
  WindowSpec,
  WindowClause,
  JoinType
} from './types';

export type { TableView } from './table-view';



// Re-export specific apache-arrow types that are commonly used
export type { DataType, Schema, Table } from 'apache-arrow';

// Export MaterializedTableData class
export { MaterializedTableData } from './table-data';

// Export utility functions and enums
export {
  isDateType,
  isNumericType,
  isStringType,
  isBooleanType,
  createColumnRef,
  // Enums
  LogicalType,
  PhysicalColumnType,
  TableFormat,
  TableSourceType,
  SQLDialect,
  WindowFunction,
  QueryType as QueryTypeEnum,
  SortDirection as SortDirectionEnum,
  AggregateOperation as AggregateOperationEnum,
  RowLimitType as RowLimitTypeEnum
} from './types'; 